export default [
  { text: "Carro", value: "car", icon: "mdi-car" },
  { text: "Moto", value: "motorcycle", icon: "mdi-motorbike" },
  { text: "Pick-up / SUV", value: "suv", icon: "mdi-car-estate" },
  { text: "Utilitário", value: "utility", icon: "mdi-van-utility" }
];
